import { useState } from "react";
import { FilePdf, FileXls } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { exportReport } from "@/lib/reportExport";
import { getErrorMessage } from "@/lib/auth";

export function ExportButtons({ type, params, testPrefix, disabledReason }) {
  const [busy, setBusy] = useState("");

  const run = async (format) => {
    if (disabledReason) { toast.error(disabledReason); return; }
    setBusy(format);
    try {
      const n = await exportReport(type, params, format);
      toast.success(`${format === "pdf" ? "PDF" : "Excel"} downloaded (${n} rows)`);
    } catch (err) {
      toast.error(err.response ? getErrorMessage(err) : err.message);
    } finally { setBusy(""); }
  };

  return (
    <div className="flex gap-1.5 flex-shrink-0">
      <Button variant="outline" size="sm" disabled={!!busy} onClick={() => run("pdf")} className="h-8 px-2.5 text-xs border-red-200 text-red-700 hover:bg-red-50" data-testid={`${testPrefix}-pdf`}>
        <FilePdf size={14} className="mr-1" weight="bold" /> {busy === "pdf" ? "..." : "PDF"}
      </Button>
      <Button variant="outline" size="sm" disabled={!!busy} onClick={() => run("excel")} className="h-8 px-2.5 text-xs border-green-200 text-green-700 hover:bg-green-50" data-testid={`${testPrefix}-excel`}>
        <FileXls size={14} className="mr-1" weight="bold" /> {busy === "excel" ? "..." : "Excel"}
      </Button>
    </div>
  );
}
